import React from 'react';
import { SidebarPageLayout } from '@layout/SidebarPageLayout';
import { PageProps } from '@model/pages';
import { PageConfig } from '@model/content';
import { Error500 } from '@components/common/hero/error/Error500';
import { ERROR_CODES } from '@model/common/error-codes';

/* ***************** *
 *       Types       *
 * ***************** */
export interface GenericHelpPageLayoutProps extends PageProps {
  pageConfig: PageConfig;
  path: string;
}

/* ********************* *
 *    GenericHelpPage    *
 * ********************* */
export const GenericHelpPageLayout = ({ pageConfig, path, promoBannerTripType }: GenericHelpPageLayoutProps) => {
  if (!pageConfig) {
    return <Error500 code={ERROR_CODES.NO_CMS_CONFIG} />;
  }

  const { components } = pageConfig;

  return (
    <>
      <SidebarPageLayout components={components} path={path} promoBannerTripType={promoBannerTripType} />
    </>
  );
};
